// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XlIb","content":"styles_content__1Y8D8","tableWrap":"styles_tableWrap__2sEL7"};